<app-component-header></app-component-header>

<div class="col-xs-12 col-sm-12 margin-information-footer" style="text-align: center;">
    <div class="space-top">
        <div class="spinner-border text-primary" role="status" [hidden]="isSendingData">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-align" [hidden]="isSendingData"></div>
        <div id="content-completed">
            <div class="row">
                <div class="col-xs-12 col-sm-12">
                    <qrcode [cssClass]="'center'" [scale]="1" margin="4" [allowEmptyString]="true" [qrdata]="imgQrCode"
                        [imageSrc]="'assets/img/Logo_qr.png'" [imageHeight]="20" [imageWidth]="80"
                        [colorDark]="'#000000ff'" [colorLight]="'#ffffffff'" [width]="256" [errorCorrectionLevel]="'H'"
                        [elementType]="'canvas'" *ngIf="imgQrCode">
                    </qrcode>
                </div>
                <div class="col-xs-12 col-sm-12 success-noti">
                    <p>Quý khách đã đăng ký thành công!</p>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-12 information-enterprise">
                    <div class="col-xs-3 col-sm-3 enterprise-info-left">
                        <label id="lblEnterprise_title" class="class-title custom-height" for="lblEnterprise_title">Tên
                            doanh nghiệp</label>
                        <p id="lblEnterprise_value" class="class-value" for="lblEnterprise_value">{{enterprise}}</p>
                    </div>
                    <div class="col-xs-3 col-sm-3 enterprise-info-right">
                        <label id="lblAccNum_title" class="class-title custom-height" for="lblAccNum_title">Số GCN
                            ĐKKD/GCN ĐKDN/QĐ thành lập/GCN ĐKĐT</label>
                        <p id="lblAccNum_value" class="class-value" for="lblAccNum_value">{{account_number}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-12 lbl-noti">
                    <p>Chúng tôi sẽ gửi thông tin hợp đồng và tài khoản ebanking qua email quý khách đã đăng ký</p>
                </div>
            </div>
            <div class="row">
                <div class="text-center div-center">
                    <button nz-button nzType="primary" nzSize="large" nzShape="round" class="btn-blue"
                        (click)="downloadQRCode()">Download QRCode</button>
                    <button nz-button nzType="primary" nzSize="large" nzShape="round" class="btn-blue"
                        (click)="printForm()">In biểu mẫu</button>
                </div>
            </div>
        </div>
    </div>
</div>

<app-component-footer></app-component-footer>